export default "__VITE_ASSET__DNwjFlVK__"